/* eslint-disable no-undef */
export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://192.168.50.165:8000/api";

export const LOCAL_STORAGE_ENCRYPTION_KEY =
  process.env.REACT_APP_LOCAL_STORAGE_ENCRYPTION_KEY ||
  "Socomplexsecretthatnobodywilleverknow";
